module.exports = __webpack_public_path__ + "media/images/common/beginner-2b7d6e7de2578ab82cc553d3fbeb04f9.gif";